import React from 'react';
import { Section } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { INSTRUCTOR_IMAGE } from '../../data/content';
export function WhyWeCreated() {
  return <Section data-id="element-251" data-mp="34j3aajdr96nb">
      <div className="grid items-center gap-6 lg:grid-cols-[minmax(0,340px)_minmax(0,1fr)] lg:gap-10" data-id="element-252" data-mp="34jldy12qyn59">
        <div className="mx-auto w-full max-w-[280px] lg:max-w-none" data-id="element-253" data-mp="39hmwmkw9gkg7">
          <img src={INSTRUCTOR_IMAGE} alt="The welding instructor behind Master Welding System, standing in his workshop" className="w-full rounded-2xl border border-white/10 object-cover" width={928} height={1160} data-id="element-254" data-mp="39ftlasapdc1v" />
        </div>

        <div data-id="element-255" data-mp="3nbxgantehofe">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-teal-bright sm:text-xs" data-id="element-256" data-mp="3s8e2vdkybuqd">
            ⚙️ From the workshop
          </p>
          <h2 className="mt-2 font-display text-[26px] font-bold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-257" data-mp="2bsup0inxa64i">
            Why we created Master Welding System™
          </h2>
          <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-258" data-mp="3j13x8yqeng2u">
            <p data-id="element-259" data-mp="3e213wbjseyap">
              Most people don’t struggle with welding because they lack the
              ability. They struggle because nobody gave them a clear process to
              follow before striking the arc.
            </p>
            <p data-id="element-260" data-mp="3n3s8fd2lcz2z">
              They learn from scattered videos. Different welders recommend
              different settings. They waste material trying to figure things out
              through trial and error. And eventually, they start believing
              welding is much harder than it actually is.
            </p>
            <p className="font-semibold text-white" data-id="element-261" data-mp="ak98soacty8a">
              Master Welding System™ was created to change that.
            </p>
            <p data-id="element-262" data-mp="ol3h76xejz6y">
              It’s not another long course filled with theory. It’s a practical
              welding reference system designed to help you know what to check,
              what to adjust and what to do each time you weld.
            </p>
          </div>
        </div>
      </div>

      <CtaBlock className="mt-10" headline="Follow a clear process from your next weld on" data-id="element-263" data-mp="3hfk5e5i2q61j" />
    </Section>;
}